import { Col, Form, Row } from 'antd'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import { isEmpty } from 'lodash'
import { fullWidthFormItemLayout } from '../../../../modules/FormItems'
import React from 'react'


function DocLinkToForm(props) {
  const { linkToType } = props
  console.log(linkToType)
  const { getFieldDecorator } = props.form

  let url = ''
  switch (linkToType) {
    case 'RFQ':
      {
        url = `rfq?select=_id,code,title,status`
      }
      break
    case 'Quotation':
      {
        url = 'quotes?select=_id,code,title,status'
      }
      break
  }

  const [GenericSelect] = useFetchSelectUrl(
    {
      name: 'select',
      url: url,
      cache: false,
    },
    [url],
    isEmpty(url),
    undefined,
    r => ({ ...r, display: `[${r.code}] (${r.status}) - ${r.title}` }),
    () => {},
    true,
  )

  return (
    <Form>
      <Row>
        <FormSectionTitle title={'Select a document To Link'} />
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label={linkToType}>
            {getFieldDecorator('_id', {
              rules: [{ required: true, message: 'Please Select a Title!' }],
            })(
              <GenericSelect
                style={{ width: '100%' }}
                keyAtr={'_id'}
                valueAtr={'display'}
                placeholder={`Select a ${linkToType}`}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default Form.create()((DocLinkToForm))
